import { createRouter, createWebHistory } from 'vue-router';
import { setCurrentMfeRoute } from 'host/mfeBridge';
import { createRoutes } from '@Router/routes';
import { getBasePath } from '@Src/mfe.config';
import { useDashboardStore } from '@Stores/dashboard.store';

const basePath = getBasePath() ?? '/';
const router = createRouter({
    history: createWebHistory(),
    routes: createRoutes(basePath),
});

router.beforeEach(async (to, _from, next) => {
    setCurrentMfeRoute(to);

    if (to.meta?.requiresAuth) {
        const dashboardStore = useDashboardStore();
        if (!dashboardStore.isLoaded && !dashboardStore.isLoading) {
            await dashboardStore.loadDashboard();
        }
    }

    next();
});

export default router;
